import {IParams, RecursosController} from "../recursos";

export class TiktokController extends RecursosController {

    /* INSTANCE */
    public static instance: TiktokController;
    private reloadJS: boolean;
    private reloadOK: boolean;

    /* STATIC */
    public static override async build(): Promise<void> {
        TiktokController.instance = new this();
        RecursosController.instances.push(TiktokController.instance);
    }

    private constructor() {
        super();
        this.reloadJS = false;
        this.reloadOK = false;
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const resources = Array.from(html.querySelectorAll("[class*='tiktok-body'], [class*='tiktok-live']"));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement) : Promise<void> {
        if (this.reloadJS) {
            document.getElementById("script-tiktok")?.remove();
            this.reloadOK = true;
        }
        const params = JSON.parse(item.getAttribute('data-lazy')!.replace(/'/g,"\""));
        const urls: IParams[] = [{name: "script-tiktok", value: "https://www.tiktok.com/embed.js"}];
        const promesas = await this.initPromises(urls);
        await Promise.all(promesas).then(async ()=>{
            const element = new DOMParser().parseFromString(params.html, "text/html").body.firstChild as HTMLElement;
            item.appendChild(element);
            if (!this.providerItems[item.id]) {
                this.providerItems[item.id] = item;
            } else {
                if (!this.reloadOK) {
                    this.reloadJS = true;
                }
            }
        });
    }

}
